import { ShieldStarIcon } from '@phosphor-icons/react';
import type { JSX } from 'react';

import { IssuesTable } from '@/components/issue-reporting/admin/IssuesTable';
import { UsagePanel } from '@/components/issue-reporting/admin/UsagePanel';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

/**
 * Super-Admin console at the UNLINKED /super-admin route (no nav entry anywhere). The route is wrapped
 * in <RequireRole role="Super Admin"> for UX/obscurity — the real authorization boundary is the
 * server, where every admin endpoint is gated with [Authorize(Roles = "Super Admin")].
 */
export function SuperAdminDashboardPage(): JSX.Element {
  return (
    <div className="space-y-6" data-testid="super-admin-dashboard">
      <div className="flex items-center gap-2">
        <ShieldStarIcon size={28} weight="fill" className="text-primary" />
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Super Admin</h1>
          <p className="text-muted-foreground">Reported issues and platform usage.</p>
        </div>
      </div>

      <Tabs defaultValue="issues">
        <TabsList>
          <TabsTrigger value="issues" data-testid="tab-issues">
            Issues
          </TabsTrigger>
          <TabsTrigger value="usage" data-testid="tab-usage">
            Usage
          </TabsTrigger>
        </TabsList>

        <TabsContent value="issues" className="pt-4">
          <Card>
            <CardHeader>
              <CardTitle>Reported issues</CardTitle>
              <CardDescription>
                Click a row to view captured diagnostics and triage the report.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <IssuesTable />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="usage" className="pt-4">
          <UsagePanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}

export default SuperAdminDashboardPage;
